import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.559 2.036a.52.52 0 0 0-.52.518v20.724a.52.52 0 0 0 .52.518h16.626a.52.52 0 0 0 .52-.518V7.95l-5.93-5.914H2.558zm16.626 22.797H2.559c-.86 0-1.559-.698-1.559-1.555V2.554C1 1.697 1.7 1 2.559 1h11.43c.138 0 .27.054.368.152l6.234 6.217a.516.516 0 0 1 .153.366v15.543c0 .857-.7 1.555-1.56 1.555z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.224 8.253h-6.235a.519.519 0 0 1-.52-.518V2.036h1.04v5.181h5.715v1.036zM10.872 9.808H4.637a.519.519 0 1 1 0-1.036h6.235a.519.519 0 1 1 0 1.036M17.107 12.916H4.637a.519.519 0 1 1 0-1.036h12.47a.519.519 0 1 1 0 1.036M17.107 16.025H4.637a.519.519 0 1 1 0-1.036h12.47a.519.519 0 1 1 0 1.036M17.107 19.134H4.637a.519.519 0 1 1 0-1.037h12.47a.519.519 0 1 1 0 1.037"
});
var Paper = function Paper(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "21",
    height: "26",
    viewBox: "0 0 21 26"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: color,
    fillRule: "evenodd",
    stroke: color,
    strokeWidth: ".5"
  }, _ref2, _ref3));
};
export default Paper;